var render = function render(){
  var _vm$file, _vm$file2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-badge', {
    staticClass: "d-flex align-items-center justify-content-between"
  }, [(_vm$file = _vm.file) !== null && _vm$file !== void 0 && _vm$file.id ? _c('div', {
    staticClass: "text-white cursor-pointer",
    on: {
      "click": _vm.handleDownloadFile
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-download cursor-pointer"
  }), _c('p', {
    staticClass: "ml-2 mb-0"
  }, [_vm._v("Attachment")])])]) : _c('a', {
    staticClass: "text-white",
    attrs: {
      "href": (_vm$file2 = _vm.file) === null || _vm$file2 === void 0 ? void 0 : _vm$file2.url,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-download cursor-pointer"
  }), _c('p', {
    staticClass: "ml-2 mb-0"
  }, [_vm._v("Attachment")])])]), !_vm.isPreview ? _c('i', {
    staticClass: "fa fa-close cursor-pointer",
    on: {
      "click": _vm.onClickDelete
    }
  }) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }